// 自动带出部门
export const getUserDefaultDepart = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/GetMyDepartments',
};

//获取成本中心
export const getCostCenter = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/GetCostCenterV2',
};

//获取成本中心
export const getCostCenterV3 = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/GetCostCenterV3',
};

//获取员工基本信息
export const GetCustomerBaseInfoList = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/GetCustomerBaseInfoList',
};

//获取员工基本信息
export const ValidateBudget = {
  module: 'common',
  method: 'POST',
  address: 'api/Budget/ValidateBudget',
};

// 埋点接口
export const BuryingPoint = {
  module: 'tripwise-m-api',
  method: 'POST',
  address: 'event-tracking/add',
};

//获取员工是否统一代订
export const IsPrivilegeStaffs = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/IsPrivilegeStaffs',
};

//查询审批人
export const GetMyApprovaler = {
  module: 'common',
  method: 'POST',
  address: 'api/TravelApprovalManager/GetMyApprovaler',
};

//初始化接口
export const LoginInit = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/LoginInit',
};

//获取行程列表
export const GetTripList = {
  module: 'common',
  method: 'POST',
  address: 'api/order/GetTripList',
};

//获取行程失败未读数量
export const GetReadFlag = {
  module: 'common',
  method: 'POST',
  address: 'api/order/GetReadFlag',
};

//更新行程失败未读数量
export const UpdateReadFlag = {
  module: 'common',
  method: 'POST',
  address: 'api/order/UpdateReadFlag',
};

//搜索行程列表
export const GetSearchTripList = {
  module: 'common',
  method: 'POST',
  address: 'api/order/GetSearchTripList',
};

//获取第三方出差单
export const GetExternalOrderInfos = {
  module: 'common',
  method: 'POST',
  address: 'api/travelBusinessOrder/GetExternalOrderInfos',
};
//获取员工多账号信息
export const GetLoginUserInfos = {
  module: 'common',
  method: 'POST',
  address: 'api/Customer/GetLoginUserInfos',
};
